import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import { Cache } from 'aws-amplify';
import { getProject, resetProject, resetPlatformBands, PENDING } from '../../store/actions/projects/projectsActions';
import { updateMembers } from '../../store/actions/projects/projectMembersActions';
import { toggleDialogBox } from '../../store/actions/commonActions';
import { 
  MANAGER, 
  PORTAL_ADMIN, 
  PROJECT_ADMIN, 
  PROJECT_SPONSOR, 
  FINANCE_APPROVER,
  TEAM_LEADER, 
  EMPLOYEE} from '../../store/actions/users/usersActions';

import ProjectMembers from './ProjectMembers';
import ManageMembers from './ManageMembers';
import ApprovalWorkflow from './ApprovalWorkflow';
import ProjectCosting from './ProjectCosting';
import CompleteDetails from './CompleteDetails';

import SettingsMenu from '../../common/SettingsMenu';
import ProjectForm from './ProjectForm';

class ViewProject extends Component {

  constructor(props) {
    super(props);
    this.roleId = '';
    this.projectId = 0;
    this.budgetedHours = 0;
    this.projectName = '';
    this.view = '';
  }

  componentDidMount() {
    this.roleId = Cache.getItem('roleId');
    if (this.roleId === PORTAL_ADMIN 
        || this.roleId === MANAGER  
        || this.roleId === FINANCE_APPROVER 
        || this.roleId === PROJECT_ADMIN
        || this.roleId === PROJECT_SPONSOR
        || this.roleId === TEAM_LEADER
        || this.roleId === EMPLOYEE) {
      const urlParams = new URLSearchParams(this.props.location.search);
      const projectId =  urlParams.get('id');
      this.props.getProject(projectId, true);
      this.projectId = projectId;
    }
    else {
      this.props.history.push('/dashboard');
    }
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.props.resetProject();
    this.props.resetPlatformBands();

    Cache.removeItem('projectName');
  }

  switchProjectView = () => {
    const urlParams = new URLSearchParams(this.props.location.search);
    const view = urlParams.get('view');   
    switch(view) {
      case 'details':
        return <CompleteDetails project={this.project} fromViewProj={true} />
      case 'update':
        return <ProjectForm />
      case 'members': 
        return <ProjectMembers project={this.project} />
      case 'approval_workflow':
        return <ApprovalWorkflow project={this.project} />
      case 'costing':
        return <ProjectCosting project={this.project} />
      default:
        return <CompleteDetails project={this.project} fromViewProj={true} />
    }
  }

  render() {
    const project = this.props.projects.project;
    this.project = project;
    let optionMenus = [];
    // let optionMenus = [
    //   {optionUrl: '/projects/update?id=' + this.projectId, optionName: 'Edit Project Details'}, 
    //   {optionUrl: '/projects/tasks?id=' + this.projectId, optionName: 'Manage Tasks'}, 
    //   {optionUrl: '/projects/view?id=' + this.projectId + '&view=members', optionName: 'Team Members'},
    //   {optionUrl: '/projects/view?id=' + this.projectId + '&view=approval_workflow', optionName: 'Approvers'}, 
    //   {optionUrl: '/projects/view?id=' + this.projectId + '&view=costing', optionName: 'Project Costing'},  
    // ]


    switch(this.roleId) {
      case PROJECT_ADMIN: 
      case PORTAL_ADMIN: 
        
        if (project.status !== PENDING) {
          optionMenus.push(
            {optionUrl: '/projects/update?id=' + this.projectId, optionName: 'Edit Project Details'}, 
            {optionUrl: '/projects/tasks?id=' + this.projectId, optionName: 'Manage Tasks'}, 
            {optionUrl: '/projects/view?id=' + this.projectId + '&view=members', optionName: 'Team Members'},
          );
        }
        else {
          optionMenus.push(
            {optionUrl: '/projects/tasks?id=' + this.projectId, optionName: 'Manage Tasks'}, 
            {optionUrl: '/projects/view?id=' + this.projectId + '&view=members', optionName: 'Team Members'},
          )
        }
        break;

      case PROJECT_SPONSOR:
        if (project.status !== PENDING) {
          optionMenus.push(
            {optionUrl: '/projects/view?id=' + this.projectId + '&view=members', optionName: 'Team Members'},
            {optionUrl: '/projects/tasks?id=' + this.projectId, optionName: 'Manage Tasks'}, 
          );
        }
        break;

      case MANAGER:
        if (project.status !== PENDING) {
          optionMenus = [
            {optionUrl: '/projects/view?id=' + this.projectId + '&view=members', optionName: 'Team Members'},
            {optionUrl: '/projects/tasks?id=' + this.projectId, optionName: 'Manage Tasks'}, 
          ]
        }
        break;

      case FINANCE_APPROVER:
        optionMenus = [
          {optionUrl: '/projects/view?id=' + this.projectId + '&view=costing', optionName: 'Project Costing'},  
        ]
        break;

        case TEAM_LEADER:
          if (project.status !== PENDING) {
            optionMenus = [
              {optionUrl: '/projects/view?id=' + this.projectId + '&view=members', optionName: 'Team Members'},
              {optionUrl: '/projects/tasks?id=' + this.projectId, optionName: 'Manage Tasks'}, 
            ]
          }
          break;      
        
      default:
        optionMenus = []
        break;
    }

    let projectName = Cache.getItem('projectName');
    
    if (!projectName) {
      Cache.setItem('projectName', project.project_name);
      projectName = project.project_name;
    }

    if (!Object.keys(project).length) {
      return 'Loading...';
    }

    return (
      <Row>
        <ManageMembers />
        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <Row>
            <Col xs={8} sm={8} md={8} lg={8} xl={8}>
              <Link to="#" className="header-link" onClick={(e) => {
                e.preventDefault();
                const url = '/projects/view?id=' + project.id;
                this.props.history.push(url);
              }}>
                <h5 id="project-title">{projectName}</h5>
              </Link>
            </Col>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              { project.is_disabled || this.roleId === EMPLOYEE ? '' : <SettingsMenu options={optionMenus}/> }
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              {this.switchProjectView()}
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects
})

const mapDispatchToProps = (dispatch) => {
  return {
    getProject: (...args) => dispatch(getProject(...args)),
    toggleDialogBox: (...args) => dispatch(toggleDialogBox(...args)),
    resetProject: () => dispatch(resetProject()),
    updateMembers: (...args) => dispatch(updateMembers(...args)),
    resetPlatformBands: () => dispatch(resetPlatformBands())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewProject));
